import React from 'react';
import { Col, DatePicker, Radio, Row, Select, Checkbox, Input, Icon } from 'antd';
import moment from 'moment';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idMoneda ? { key: this.props.filter.idMoneda } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Moneda" />}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.cliente}
                            onChange={(e) => this.props.onChange("cliente", e.target.value)}
                            placeholder="Filtrar por cliente, Ruc"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idDepartamento ? { key: this.props.filter.idDepartamento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Departamento" />}
                            onChange={(option) => this.props.onChange("idDepartamento", option.key)}

                            optionFilterProp="children"
                        >
                            {this.props.departamentos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idProvincia ? { key: this.props.filter.idProvincia } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Provincia" />}
                            onChange={(option) => this.props.onChange("idProvincia", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.provincias.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idDistrito ? { key: this.props.filter.idDistrito } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Distrito" />}
                            onChange={(option) => this.props.onChange("idDistrito", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.distritos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={24} lg={6}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Ranking</Radio>
                                <Radio value={2}>Resumen</Radio>
                                <Radio value={3}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                    
                    <Col className="gutter-row" sm={24} md={24} lg={24}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                            <Radio.Group
                                value={this.props.filter.tipoComprobante}
                                onChange={(e) => this.props.onChange("tipoComprobante", e.target.value)}
                            >
                                <Radio value={1}>Solo comprobantes tributarios</Radio>
                                <Radio value={2}>Solo notas de ventas</Radio>
                                <Radio value={0}>Todos los comprobantes</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}